module.exports = __webpack_public_path__ + "img/bg_content.61447931.jpg";